export enum ReceptionPlacesActions {
    RELOAD_DATA = "reloadReceptionPlaces",
    SET_RECEPTIONPLACES = "setReceptionPlaces",
    TOGGLE_PANEL = "togglePanel",
    CLEAR = "Clear",
    SET_POSTAL_CODE = "setPostalCode",
  }